<template>
  <div class="link">
    <FontIcon :name="fontIcon" v-if="fontIcon" />
    <a class="link-text text5" @click="$emit('click')">{{ text }}</a>
  </div>
</template>

<style lang="scss">
.link {
  .font-icon {
    margin-right: rem(5px);
    font-size: rem(22px);
  }

  .link-text {
    vertical-align: top;
    @include setColor(--color-link);
  }
}
</style>
<script>
import FontIcon from "../FontIcon";
export default {
  components: {
    FontIcon,
  },
  props: {
    fontIcon: {
      type: String,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
